import { LogErrors } from './../LogErrors'

import { SaveSignUpInfo } from './../BL/Sessions'

//const URLBase = 'https://api.riactivos.com/Api/V2/'
const URLBase = process.env.REACT_APP_API_URL //'https://riactivos.xyz/Api/V2/'


const SignUp = async (formData) => {
    try {
        const dataToSend = {
            curp: formData.curp,
            name: formData.name,
            paternalSurname: formData.paternalSurname,
            maternalSurname: formData.maternalSurname,
            birthOfDate: formData.birthdate,
            previousSchool: formData.nameOfHomeSchool,
            idNormalSchoolGeographicStates: formData.state,
            idNormalSchoolSectors: formData.sector,
            overallAverage: formData.average,
            idMajorsByNormalSchool: formData.major
        }
        
        const response = await fetch(URLBase + "Applicant/CreateApplicants", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            //return { success: false, message: errorData.message }

            // Retornamos el status para poder identificar el 409 en la capa BL
            return { success: false, status: response.status, message: errorData.message }
        }
        
        const data = await response.json()
      
        
        // Guardar datos en sessionStorage
        const applicantData = {
            curp: formData.curp,
            name: formData.name,
            paternalSurname: formData.paternalSurname,
            maternalSurname: formData.maternalSurname,
            birthdate: formData.birthdate,
            nameOfHomeSchool: formData.nameOfHomeSchool,
            state: formData.state,
            nameState: formData.nameState,
            sector: formData.sector,
            nameSector: formData.nameSector,
            average: formData.average,
            normalStateId: formData.normalState,
            nameNormalState: formData.nameNormalState,
            normalSchoolId: formData.normalSchool,
            nameNormalSchool: formData.nameNormalSchool,
            nameMajor: formData.nameMajor,
            major: formData.major,
            accessCode: data.accessCode
        }
        
        await SaveSignUpInfo(applicantData)

        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('SignUp DL SignUps', error)
        return { success: false, message: '' }
    }
}

const GetAllStates = async () => {
    try {
        const response = await fetch(URLBase + "Applicant/GetNormalSchoolGeographicStates", {
            method: 'GET'
        })
        
        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            return { success: false, message: errorData.message }
        }
        
        const data = await response.json()
        
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetAllStates DL SignUps', error)
    }
}

const GetStatesContracted = async () => {
    try {
        const response = await fetch(URLBase + "Applicant/GetNormalSchoolGeographicStatesContracted", {
            method: 'GET'
        })

        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            return { success: false, message: errorData.message }
        }
        
        const data = await response.json()
    
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetStatesContracted DL SignUps', error)
    }
}

const GetNormalSchoolSectors = async () => {
    try {
        const response = await fetch(URLBase + "Applicant/GetNormalSchoolSectors", {
            method: 'GET'
        })

        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            return { success: false, message: errorData.message }
        }
        
        const data = await response.json()
    
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetNormalSchoolSectors DL SignUps', error)
    }
}

const GetNormalSchoolsByState = async (idState) => {
    try {
        const dataToSend = {
            id: idState
        }

        const response = await fetch(URLBase + "Applicant/GetNormalSchoolsByState", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })

        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            return { success: false, message: errorData.message }
        }
        
        const data = await response.json()
    
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetNormalSchoolsByState DL SignUps', error)
    }
}

const GetMajorsByNormalSchool = async (idNormalSchool) => {
    try {
        const dataToSend = {
            id: idNormalSchool
        }

        const response = await fetch(URLBase + "Applicant/GetMajorsByNormalSchool", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })

        if (!response.ok) {
            // Manejar errores HTTP
            const errorData = await response.json()
            //return { success: false, message: errorData.message || 'Error de autenticación' }
            return { success: false, message: errorData.message }
        }
        
        const data = await response.json()
    
        // Retornar la respuesta exitosa
        return { success: true, data: data }
    } catch (error) {
        await LogErrors('GetMajorsByNormalSchool DL SignUps', error)
    }
}

const ReprintAccessCode = async (formData) => {
    try {
        // const dataToSend = {
        //     curp: formData.curp,
        //     idNormalSchool: formData.normalSchool,
        //     idMajorsByNormalSchool: formData.major
        // }
        
        const dataToSend = {
            Curp: formData.curp,
            IdnormalSchool: formData.normalSchool,
            IdnormalSchoolMajors: formData.major
        }
        
        const response = await fetch(URLBase + "Applicant/ReprintAccessCode", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataToSend)
        })
        
        if (!response.ok) {
            const errorData = await response.json()
            return { success: false, status: response.status, message: errorData.message }
        }
        
        const data = await response.json()
        
        // Guardamos la información en sesión para que RegisteredApplicant.js la pueda leer.
        // NOTA: Se asume que el endpoint ReprintAccessCode devuelve los datos personales (name, birthdate, etc.) 
        // además del accessCode. Hacemos un spread (...data) para incluir todo lo que retorna.
        // const applicantData = {
        //     curp: formData.curp,
        //     normalStateId: formData.normalState,
        //     nameNormalState: formData.nameNormalState,
        //     normalSchoolId: formData.normalSchool,
        //     nameNormalSchool: formData.nameNormalSchool,
        //     nameMajor: formData.nameMajor,
        //     major: formData.major,
        //     accessCode: data.accessCode,
        //     ...data // Incorpora name, paternalSurname, maternalSurname, birthdate, average, etc., que requiere la UI final
        // }

        // --- MAPEO DE DATOS PARA COMPATIBILIDAD CON LA UI ---
        const applicantData = {
            // Datos personales
            curp: formData.curp,
            name: data.name,
            paternalSurname: data.paternalSurname,
            maternalSurname: data.maternalSurname,
            birthdate: data.birthOfDate, // Mapeo: birthOfDate -> birthdate
            
            // Escuela de procedencia
            nameOfHomeSchool: data.previousSchool, // Mapeo: previousSchool -> nameOfHomeSchool
            nameState: data.applicantState, // Mapeo: applicantState -> nameState
            nameSector: data.sectorName, // Mapeo: sectorName -> nameSector
            average: data.overallAverage, // Mapeo: overallAverage -> average
            
            // Escuela Normal destino
            normalStateId: formData.normalState,
            nameNormalState: data.state, // Mapeo: state -> nameNormalState
            normalSchoolId: data.normalSchoolId,
            nameNormalSchool: data.normalSchool, // Mapeo: normalSchool -> nameNormalSchool
            major: formData.major,
            nameMajor: data.major, // Mapeo: major -> nameMajor
            
            // Resultado
            accessCode: data.accessCode
        }
        
        await SaveSignUpInfo(applicantData)

        return { success: true, data: data }
    } catch (error) {
        await LogErrors('ReprintAccessCode DL SignUps', error)
        return { success: false, message: '' }
    }
}

export { SignUp, GetAllStates, GetStatesContracted, GetNormalSchoolSectors, GetNormalSchoolsByState, GetMajorsByNormalSchool, ReprintAccessCode };